"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/namespace */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
const react_1 = __importStar(require("react"));
const de_ui_1 = require("@delab-team/de-ui");
const ton3_1 = require("ton3");
const ton_1 = require("@ton/ton");
const validatorus_react_1 = require("validatorus-react");
const axios_1 = __importDefault(require("axios"));
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const react_2 = require("@nanostores/react");
const stores_1 = require("./stores");
const swap_1 = require("./pages/swap");
const apps_api_1 = require("./logic/apps-api");
const spinner_1 = require("./components/spinner");
const layout_1 = require("./layout");
const wallet_1 = require("./logic/wallet");
const events_1 = require("./logic/events");
const reg_1 = require("./logic/reg");
const tonapi_1 = require("./logic/tonapi");
require("./utils/i18n");
const useLoadUserData_1 = require("./hooks/useLoadUserData");
require("./styles/style.css");
require("./styles/themes.css");
const pswchange_1 = __importDefault(require("./pages/pswchange"));
const getClient_1 = require("./utils/getClient");
const Main = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./pages/main'))));
const Reg = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./pages/reg'))));
const Settings = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./pages/settings'))));
const TonConnectPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./pages/tonconnect'))));
const TonConnectQRPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./pages/qr'))));
const Apps = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./pages/apps'))));
const RedirectToTelegram = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./pages/redirect-to-telegram'))));
const App = () => {
    const { storeMain } = (0, stores_1.useStores)();
    const { getJettons } = (0, useLoadUserData_1.useLoadUserData)();
    const { i18n, t } = (0, react_i18next_1.useTranslation)();
    const tonapi = new tonapi_1.TonApi();
    const storeMainRepository = (0, react_2.useStore)(storeMain.repository);
    const TgObj = sdk_1.default;
    TgObj.setHeaderColor(storeMainRepository.isLightTheme ? '#FFF' : '#212325');
    TgObj.setBackgroundColor(storeMainRepository.isLightTheme ? '#FFF' : '#212325');
    const [isTg, setIsTg] = react_1.default.useState(false);
    const [activeModal, setActiveModal] = react_1.default.useState(null);
    const [firstRender, setFirstRender] = react_1.default.useState(false);
    (0, react_1.useEffect)(() => {
        if (firstRender) {
            TgObj.MainButton.show();
            TgObj.MainButton.disable();
            TgObj.MainButton.color = '#424B56';
            TgObj.MainButton.text = 'DeWallet 2024';
            TgObj.MainButton.showProgress();
        }
    }, [firstRender]);
    const [addressUser, setAddressUser] = react_1.default.useState(undefined);
    const [headerAddressUser, setHeaderAddressUser] = react_1.default.useState(undefined);
    const [auth, setAuth] = react_1.default.useState(false);
    const [loadingData, setLoadingData] = react_1.default.useState(true);
    //= ======================
    // tokens data
    const [tokensData, setTokensData] = react_1.default.useState(undefined);
    const [totalBalance, setTotalBalance] = react_1.default.useState('0.00');
    // const [ tokensLoading, setTokensLoading ] = React.useState<boolean>(true)
    const [walletBalanceTON, setWalletBalanceTON] = react_1.default.useState(undefined);
    const [priceTON, setPriceTON] = react_1.default.useState(undefined);
    // console.log('TOTAL BALANCE', totalBalance)
    // console.log('TOKENS DATA', tokensData)
    //= =======================================================================================================================================================
    // Modal States
    // receive
    const [showReceiveModal, setShowReceiveModal] = react_1.default.useState(false);
    // send
    const [showSendModal, setShowSendModal] = react_1.default.useState(false);
    // connect
    const [showConnectModal, setShowConnectModal] = react_1.default.useState(false);
    const [tokenSwap, setTokenSwap] = react_1.default.useState(undefined);
    // transaction detail
    const [showTransactionDetail, setShowTransactionDetail] = react_1.default.useState(false);
    const [jettonDetailData, setJettonDetailData] = react_1.default.useState({
        token: '',
        tokenAddress: '',
        tokenLogo: '',
        availableBalance: '0',
        amount: '0'
    });
    // show buy modal
    const [showBuyModal, setShowBuyModal] = react_1.default.useState(false);
    // jetton detail modal
    const [showJettonDetail, setShowJettonDetail] = react_1.default.useState(false);
    const [eventApi, setEventApi] = react_1.default.useState(undefined);
    const [transFromEvent, setTransFromEvent] = react_1.default.useState(undefined);
    const [tonConnect2Abount2, setTonConnect2Abount2] = react_1.default.useState(undefined);
    //= =======================================================================================================================================================
    // Send Transaction Data
    const [sendData, setSendData] = react_1.default.useState({
        token: '',
        sendAddress: '',
        tokenAddress: '',
        amount: '0',
        availableBalance: '0',
        decimals: 9
    });
    const [skipUserAddress, setSkipUserAddress] = react_1.default.useState(false);
    //= ================================================= swap
    const [isSwapSuccess, setIsSwapSuccess] = react_1.default.useState(false);
    //= ==================== tonconnect
    const [urlTonConnectQRQuerry, setUrlTonConnectQRQuerry] = react_1.default.useState(undefined);
    //= =======================================================================================================================================================
    const [nftDetail, setNftDetail] = react_1.default.useState(undefined);
    const history = (0, react_router_dom_1.useNavigate)();
    const wall = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    const navigate = (0, react_router_dom_1.useNavigate)();
    const psw = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 4, 160).withFname('Password');
    async function deletedAccount(password) {
        // const res = await wall.delWallet(password)
        // if (!res) {
        //     TgObj.showAlert(t('common.incorrect-password'))
        //     return
        // }
        history('/reg');
        setAuth(false);
        setAddressUser(undefined);
    }
    const getUserData = async (address) => {
        if (address === undefined) {
            return false;
        }
        const res = await getJettons(address);
        // console.log('START GET USER DATA (total balance, tokensData, tonBalance)')
        if (!res) {
            return false;
        }
        setTotalBalance(res?.totalBalance);
        setTokensData(res?.tokensData);
        setWalletBalanceTON(res?.tonBalance);
        setPriceTON(res?.tonPriceUsd);
        return true;
    };
    async function cbEventApiSend(param, type = 0) {
        // 0 - web 1 - tonconnect
        let pcc;
        console.log('cbEventApiSend', param);
        if (type === 0) {
            pcc = param[0];
            if (!pcc) {
                // consoleLog('#4001 Error params data', false)
                return undefined;
            }
            // {
            //     value: Number(transaction.value),
            //     to: transaction.to,
            //     dataType: 'boc',
            //     data: transaction.payload,
            //     stateInit: transaction.stateInit
            // }
        }
        else {
            let msgs;
            try {
                msgs = JSON.parse(param[0]);
            }
            catch (error) {
                console.error(error);
                eventApi?.updateRes(false);
                // consoleLog('#4002 Error parse params', false)
                return undefined;
            }
            console.log(msgs);
            pcc = {
                value: msgs.messages[0].amount,
                to: msgs.messages[0].address,
                data: msgs.messages[0].payload,
                dataType: 'boc'
            };
        }
        console.log(pcc);
        setSendData({
            ...sendData,
            sendAddress: pcc.to,
            amount: ton3_1.Coins.fromNano(pcc.value).toString(),
            token: 'TON'
        });
        setTransFromEvent(pcc);
        setActiveModal('send_confirm');
        return true;
    }
    async function tonProof() {
        const key = await wall.getKeyPair(psw.value);
        if (!key) {
            TgObj.showAlert('Invalid psw');
            // setActiveModal('ton_proof')
            psw.reset(true, true);
            return false;
        }
        if (eventApi)
            eventApi.setKey(key);
        if (eventApi)
            eventApi.updateRes(true);
        return true;
    }
    async function connect(url) {
        // setActiveModal('connect2')
        const res = await axios_1.default.get(url);
        console.log(res.data);
        setTonConnect2Abount2(res.data);
        return true;
    }
    const reg = new reg_1.RegClass();
    (0, react_1.useEffect)(() => {
        if (addressUser && isTg) {
            const regUser = async () => {
                await reg.postAuth(addressUser);
            };
            regUser();
        }
    }, [addressUser, isTg]);
    (0, react_1.useEffect)(() => {
        const initApp = async () => {
            if (!firstRender) {
                setFirstRender(true);
                TgObj.MainButton.hide();
                const isTgCheck = sdk_1.default.initData.length !== 0;
                // WebAppSDK.initData !== ''
                const bodyStyle = document.body.style;
                if (isTgCheck) {
                    TgObj.ready();
                    TgObj.enableClosingConfirmation();
                    TgObj.expand();
                    setIsTg(true);
                    bodyStyle.backgroundColor = 'var(--tg-theme-bg-color)';
                    bodyStyle.setProperty('background-color', 'var(--tg-theme-bg-color)', 'important');
                }
                try {
                    if (await wall.isSaveWallet()) {
                        // console.log('START FETCH ALL USER DATA')
                        const loadData = await wall.loadHashSaveData();
                        const anyFlagsAddress = loadData.address;
                        const NonBounceableAddress = ton_1.Address.parse(anyFlagsAddress).toString({ bounceable: false });
                        if (NonBounceableAddress === 'UQB5O2cMOOuyeQ03fRTDPDCnRi1eXJZbumRQqXIZzDqKoTQn') {
                            navigate('/apps');
                            TgObj.BackButton.hide();
                            TgObj.MainButton.hide();
                        }
                        setAddressUser(NonBounceableAddress);
                        const res = await tonapi.getWalletInfo(NonBounceableAddress);
                        if (res?.name) {
                            if (res.name.endsWith('.ton') || res.name.endsWith('.t.me')) {
                                setHeaderAddressUser(res.name);
                            }
                        }
                        else {
                            setHeaderAddressUser(NonBounceableAddress);
                        }
                        await getUserData(NonBounceableAddress);
                        setEventApi(new events_1.CustomEventApi(loadData.address, loadData.public, '0', cbEventApiSend, connect));
                        setLoadingData(false);
                        storeMain.setShowNavigation(true);
                    }
                    else {
                        setLoadingData(false);
                    }
                }
                catch (error) {
                    console.error('Error during data retrieval:', error);
                }
                finally {
                    TgObj.MainButton.hideProgress();
                    TgObj.MainButton.hide();
                }
            }
        };
        initApp();
    }, []);
    const [dataLoaded, setDataLoaded] = react_1.default.useState(false);
    (0, react_1.useEffect)(() => {
        const checkAuth = async () => {
            try {
                const authh = await wall.isAuth();
                if (!authh) {
                    if (window.location.pathname !== '/tonconnect') {
                        history('/reg');
                        setAuth(false);
                        return;
                    }
                }
                setAuth(true);
            }
            catch (error) {
                console.error('Error checking authentication:', error);
                history('/reg');
                setAuth(false);
            }
        };
        if (!loadingData && !dataLoaded) {
            checkAuth();
            setDataLoaded(true);
        }
    }, [history, loadingData]);
    (0, react_1.useEffect)(() => {
        if (window.location.pathname !== '/reg') {
            TgObj.SettingsButton.show();
            TgObj.SettingsButton.onClick(() => navigate('/settings'));
        }
        else {
            TgObj.SettingsButton.hide();
        }
        TgObj.SettingsButton.offClick(() => navigate('/settings'));
    }, [window.location.pathname]);
    (0, react_1.useEffect)(() => {
        TgObj.BackButton.hide();
    }, []);
    const savedLanguage = localStorage.getItem('i18nextLng');
    const [selectedLanguage, setSelectedLanguage] = react_1.default.useState(savedLanguage || 'en');
    (0, react_1.useEffect)(() => {
        const initializeLanguage = async () => {
            const TgLanguage = TgObj?.initDataUnsafe?.user?.language_code;
            let language;
            const userDefinedLanguage = localStorage.getItem('i18nextLngOwn');
            if (userDefinedLanguage) {
                language = userDefinedLanguage;
            }
            else if (TgLanguage) {
                const lowerCaseTgLanguage = TgLanguage.toLowerCase();
                if (lowerCaseTgLanguage === 'ru' || lowerCaseTgLanguage === 'en') {
                    language = lowerCaseTgLanguage;
                }
                else {
                    language = 'en';
                }
            }
            else {
                language = 'en';
            }
            setSelectedLanguage(language);
        };
        if (isTg && !savedLanguage) {
            initializeLanguage();
        }
    }, [isTg]);
    (0, react_1.useEffect)(() => {
        i18n.changeLanguage(selectedLanguage);
        localStorage.setItem('i18nextLng', selectedLanguage);
    }, [selectedLanguage, i18n]);
    // console.log('wall.loadVersionSaveData()', wall.loadVersionSaveData())
    // console.log('wall.loadHashSaveData()', wall.loadHashSaveData())
    (0, react_1.useEffect)(() => {
        localStorage.setItem('IS_LIGHT_COLOR_THEME', storeMainRepository.isLightTheme.toString());
        document.documentElement.setAttribute('data-theme', storeMainRepository.isLightTheme ? 'light' : 'dark');
        sdk_1.default.setHeaderColor(storeMainRepository.isLightTheme ? '#FFF' : '#212325');
        sdk_1.default.setBackgroundColor(storeMainRepository.isLightTheme ? '#FFF' : '#212325');
        document.body.style.backgroundColor = storeMainRepository.isLightTheme ? '#FFF' : '#212325';
    }, [storeMainRepository.isLightTheme]);
    // useEffect(() => {
    //     if (!addressUser) {
    //         return
    //     }
    //     getUserData(addressUser)
    // }, [ addressUser ])
    // useEffect(() => {
    //     const intervalId = setInterval(() => {
    //         if (!addressUser) {
    //             return
    //         }
    //         getUserData(addressUser)
    //     }, 30000)
    //     return () => clearInterval(intervalId)
    // }, [ addressUser ])
    const [isAppsLoading, setIsAppsLoading] = react_1.default.useState(true);
    const [appsData, setAppsData] = react_1.default.useState(undefined);
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            try {
                setIsAppsLoading(true);
                const api = new apps_api_1.AppsApi();
                const items = await api.getItems(selectedLanguage);
                setAppsData(items);
            }
            catch (error) {
                console.error('Error when including data:', error);
            }
            finally {
                setTimeout(() => {
                    setIsAppsLoading(false);
                }, 300);
            }
        };
        fetchData();
    }, [selectedLanguage]);
    // useEffect(() => {
    //     if (modalContentRef.current) {
    //         modalContentRef.current.scrollTop = 0
    //     }
    // }, [ window.location.pathname, modalContentRef.current ])
    // const mnem = CustomWallet.HashToKey('1982', '5bf446459a92e348fcf4ab3209a0f5ec', 'U2FsdGVkX1+ZEJVxWGsZNFiuygudAec/SiONRfluDec=')
    // console.log('MNEMONIC HANDLE', mnem)
    return ((0, jsx_runtime_1.jsx)(de_ui_1.AppInner, { isTg: isTg, children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(spinner_1.Spinner, {}), children: !isTg ? ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/", element: (0, jsx_runtime_1.jsx)(RedirectToTelegram, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/tonconnect", element: (0, jsx_runtime_1.jsx)(TonConnectPage, {}) })] })) : ((0, jsx_runtime_1.jsx)(layout_1.Layout, { isTg: isTg, isLoading: loadingData, setShowJettonDetail: setShowJettonDetail, showJettonDetail: showJettonDetail, children: loadingData ? ((0, jsx_runtime_1.jsx)(spinner_1.Spinner, {})) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: auth ? ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/", element: (0, jsx_runtime_1.jsx)(Main, { id: "main", isTg: isTg, addressUser: addressUser, 
                                    // receive modal
                                    setShowReceiveModal: setShowReceiveModal, showReceiveModal: showReceiveModal, 
                                    // send modal
                                    showSendModal: showSendModal, setShowSendModal: setShowSendModal, 
                                    // connect modal
                                    showConnectModal: showConnectModal, setShowConnectModal: setShowConnectModal, 
                                    // Transaction Detail
                                    showTransactionDetail: showTransactionDetail, setShowTransactionDetail: setShowTransactionDetail, 
                                    // Show Buy Modal
                                    showBuyModal: showBuyModal, setShowBuyModal: setShowBuyModal, 
                                    // send data
                                    sendData: sendData, setSendData: setSendData, 
                                    // psw
                                    psw: psw, 
                                    // transFromEvent
                                    transFromEvent: transFromEvent, setTransFromEvent: setTransFromEvent, 
                                    // show jetton detail modal
                                    showJettonDetail: showJettonDetail, setShowJettonDetail: setShowJettonDetail, 
                                    // jetton detail data
                                    jettonDetailData: jettonDetailData, setJettonDetailData: setJettonDetailData, eventApi: eventApi, selectedLanguage: selectedLanguage, 
                                    // tokens data
                                    tokensData: tokensData, setTokensData: setTokensData, tokenSwap: tokenSwap, setTokenSwap: setTokenSwap, nftDetail: nftDetail, setNftDetail: setNftDetail, 
                                    // ton connect qr
                                    urlTonConnectQRQuerry: urlTonConnectQRQuerry, setUrlTonConnectQRQuerry: setUrlTonConnectQRQuerry, setSkipUserAddress: setSkipUserAddress, skipUserAddress: skipUserAddress, 
                                    // other
                                    headerAddressUser: headerAddressUser, totalBalance: totalBalance, setTotalBalance: setTotalBalance, walletBalanceTON: walletBalanceTON, setWalletBalanceTON: setWalletBalanceTON, priceTON: priceTON }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/swap", element: (0, jsx_runtime_1.jsx)(swap_1.SwapPage, { addressUser: addressUser, isTg: isTg, psw: psw, tokensData: tokensData, tokenSwap: tokenSwap, isSwapSuccess: isSwapSuccess, setIsSwapSuccess: setIsSwapSuccess, setShowJettonDetail: setShowJettonDetail }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/settings", element: (0, jsx_runtime_1.jsx)(Settings, { deletedAccount: deletedAccount, addressUser: addressUser, selectedLanguage: selectedLanguage, setSelectedLanguage: setSelectedLanguage, isTg: isTg }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/changepsw", element: (0, jsx_runtime_1.jsx)(pswchange_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/qr", element: (0, jsx_runtime_1.jsx)(TonConnectQRPage, { setSendData: setSendData, sendData: sendData, setShowSendModal: setShowSendModal, urlTonConnectQRQuerry: urlTonConnectQRQuerry, setUrlTonConnectQRQuerry: setUrlTonConnectQRQuerry, setSkipUserAddress: setSkipUserAddress }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/apps", element: (0, jsx_runtime_1.jsx)(Apps, { data: appsData, isLoading: isAppsLoading, isTg: isTg, selectedLanguage: selectedLanguage }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/tonconnect", element: (0, jsx_runtime_1.jsx)(TonConnectPage, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "*", element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: '/', replace: true }) })] })) : ((0, jsx_runtime_1.jsx)(react_router_dom_1.Routes, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/reg", element: (0, jsx_runtime_1.jsx)(Reg, { id: "reg", addressUser: addressUser, setActiveModal: setActiveModal, setAddressUser: setAddressUser, isTg: isTg }) }) })) })) })) }) }));
};
exports.App = App;
